import { MOTION } from '../system/motion';
export const inputBase = {
    // Block layout: textareas are inline-block by default, which leaves a
    // baseline descender gap below them. Block strips that gap so consumers
    // don't see phantom bottom space.
    display: 'block',
    // --type-input, not body: editable controls must render at 16px or iOS
    // Safari auto-zooms the page on focus (see tokens.css).
    font: 'var(--type-input)',
    color: 'var(--foreground)',
    background: 'var(--background)',
    border: '1px solid var(--border-strong)',
    borderRadius: 'var(--radius-md)',
    // space-2 vertical / space-3 horizontal — ~36px rendered, matches Button md so
    // input+button rows pair cleanly without stretch hacks.
    padding: 'var(--space-sm) var(--space-md)',
    width: '100%',
    outline: 'none',
    transition: MOTION.transition,
};
//# sourceMappingURL=inputBase.js.map